import { Component, OnInit } from '@angular/core';
import { NebularModule } from '../../../common/modules/nebular/nebular.module';
import { SocketService } from '../../../common/services/socket.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'ngx-connection-status',
  templateUrl: './connection-status.component.html',
  styleUrls: ['./connection-status.component.scss'],
  imports: [NebularModule, CommonModule],
})
export class ConnectionStatusComponent implements OnInit {
  isConnected: boolean = true;

  constructor(private socketService: SocketService) {}

  ngOnInit() {
    this.socketService.getConnectionStatus().subscribe((isConnected) => {
      this.isConnected = isConnected;
    });
  }
}
